import {Injectable} from '@angular/core';
import {
    AbstractDataServiceDtoAdapter
} from '../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {CommunicationContentSubstitutionModel} from '../../../api/model/communicationContentSubstitution.model';
import {
    CommunicationContentSubstitutionConverter
} from '../../../api/model/converter/communicationContentSubstitution.converter';
import {CommunicationContentSubstitutionDataService} from './communicationContentSubstitutionData.service';

@Injectable({
    providedIn: 'root'
})
export class CommunicationContentSubstitutionDataServiceAdapter
    extends AbstractDataServiceDtoAdapter<CommunicationContentSubstitutionModel, CommunicationContentSubstitutionConverter> {
    constructor(dataService: CommunicationContentSubstitutionDataService, converter: CommunicationContentSubstitutionConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): CommunicationContentSubstitutionModel {
        return new CommunicationContentSubstitutionModel();
    }
}
